import { cn } from '@/lib/utils'

interface LogoProps {
  /** 'dark' = 파란 로고 (밝은 배경용), 'light' = 흰색 로고 (어두운 배경용) */
  variant?: 'dark' | 'light'
  /** 높이 기준 크기 */
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeConfig = {
  sm: 'h-7',
  md: 'h-9',
  lg: 'h-11',
} as const

export default function Logo({ variant = 'dark', size = 'md', className }: LogoProps) {
  const src = variant === 'light'
    ? '/icons/carebalance_logo.png'
    : '/icons/carebalance_logo_dark.png'

  // alt 는 variant 와 무관하게 한글 브랜드명 — 헤더 홈 링크의 링크 텍스트이자 본문 브랜드 신호다 (ssr-spec §17.1)
  return (
    <img
      src={src}
      alt="케어밸런스"
      className={cn(sizeConfig[size], 'w-auto', className)}
    />
  )
}
